"use client";

import { useMenubar } from "../__chunks/4JPBYLF3.js";
import "../__chunks/UZXETJJN.js";
import "../__chunks/QVEJ36PB.js";
import "../__chunks/IKLZZMLE.js";
import "../__chunks/5VQZOHHZ.js";
import "../__chunks/OIB4PV4M.js";
import "../__chunks/QZUWIJQN.js";
import "../__chunks/APGXEJ2Q.js";
import "../__chunks/G4PVPWEW.js";
import "../__chunks/Z4WWVOIF.js";
import "../__chunks/SWN3JYXT.js";
import { createElement, createHook, forwardRef } from "../__chunks/7FZLUSKW.js";
import "../__chunks/CTKPPFRS.js";
import "../__chunks/HNHAUIIY.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/menu/menu-bar.tsx
import { useEffect } from "react";
var TagName = "div";
var useMenuBar = createHook(function useMenuBar2(props) {
  useEffect(function () {
    if (process.env.NODE_ENV !== "production") {
      console.warn("MenuBar is deprecated. Use Menubar instead.", "See https://ariakit.org/reference/menubar");
    }
  }, []);
  return useMenubar(props);
});
var MenuBar = forwardRef(function MenuBar2(props) {
  var htmlProps = useMenuBar(props);
  return createElement(TagName, htmlProps);
});
export { MenuBar, useMenuBar };